"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useBrokenAlertFiltersMeta = void 0;
var tslib_1 = require("tslib");
// (C) 2021-2022 GoodData Corporation
var sdk_backend_spi_1 = require("@gooddata/sdk-backend-spi");
var sdk_ui_1 = require("@gooddata/sdk-ui");
var sdk_model_1 = require("@gooddata/sdk-model");
var model_1 = require("../../../../model");
/**
 * the amount of elements to load, this should be small enough to be efficient,
 * and large enough to always be longer than the broken alert filters display
 */
var DEFAULT_ATTRIBUTE_ELEMENT_COUNT = 20;
/**
 * @internal
 */
function useBrokenAlertFiltersMeta(_a) {
    var _this = this;
    var backend = _a.backend, brokenAlertFilters = _a.brokenAlertFilters, dateDatasets = _a.dateDatasets, workspace = _a.workspace, onCancel = _a.onCancel, onError = _a.onError, onLoading = _a.onLoading, onPending = _a.onPending, onSuccess = _a.onSuccess;
    var effectiveBackend = sdk_ui_1.useBackendStrict(backend, "useBrokenAlertFiltersMeta");
    var effectiveWorkspace = sdk_ui_1.useWorkspaceStrict(workspace, "useBrokenAlertFiltersMeta");
    var promise = brokenAlertFilters
        ? function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var filtersToLoad, filterDataPromise, filterData, attributeFiltersMeta;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        filtersToLoad = brokenAlertFilters.filter(model_1.isBrokenAlertAttributeFilterInfo);
                        filterDataPromise = Promise.all(filtersToLoad.map(function (filter) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                            var attributeFilter, displayForm, attributesService, elementsQueryOptions, _a, elements, displayFormData, attribute;
                            return tslib_1.__generator(this, function (_b) {
                                switch (_b.label) {
                                    case 0:
                                        attributeFilter = filter.alertFilter.attributeFilter;
                                        if (!sdk_model_1.isAttributeElementsByRef(attributeFilter.attributeElements)) {
                                            throw new sdk_backend_spi_1.NotSupported("Only URI attribute filters are supported in useBrokenAlertFiltersMeta");
                                        }
                                        displayForm = attributeFilter.displayForm;
                                        attributesService = effectiveBackend.workspace(effectiveWorkspace).attributes();
                                        elementsQueryOptions = {
                                            elements: attributeFilter.negativeSelection
                                                ? undefined // for negative filters we need to load the items NOT selected, however there is no way of doing that, so we load everything
                                                : effectiveBackend.capabilities.supportsElementUris
                                                    ? {
                                                        uris: attributeFilter.attributeElements.uris,
                                                    }
                                                    : {
                                                        primaryValues: attributeFilter.attributeElements.uris,
                                                    },
                                            includeTotalCountWithoutFilters: true,
                                        };
                                        return [4 /*yield*/, Promise.all([
                                                attributesService
                                                    .elements()
                                                    .forDisplayForm(displayForm)
                                                    .withLimit(DEFAULT_ATTRIBUTE_ELEMENT_COUNT)
                                                    .withOptions(elementsQueryOptions)
                                                    .query(),
                                                attributesService.getAttributeDisplayForm(displayForm),
                                            ])];
                                    case 1:
                                        _a = tslib_1.__read.apply(void 0, [_b.sent(), 2]), elements = _a[0], displayFormData = _a[1];
                                        return [4 /*yield*/, attributesService.getAttribute(displayFormData.attribute)];
                                    case 2:
                                        attribute = _b.sent();
                                        return [2 /*return*/, {
                                                elements: elements,
                                                displayForm: displayForm,
                                                title: attribute.title,
                                            }];
                                }
                            });
                        }); }));
                        return [4 /*yield*/, filterDataPromise];
                    case 1:
                        filterData = _a.sent();
                        attributeFiltersMeta = filterData.reduce(function (acc, curr) {
                            acc[sdk_model_1.objRefToString(curr.displayForm)] = {
                                title: curr.title,
                                totalElementsCount: curr.elements.totalCount,
                                validElements: curr.elements.items,
                            };
                            return acc;
                        }, {});
                        return [2 /*return*/, {
                                attributeFiltersMeta: attributeFiltersMeta,
                                dateDatasets: dateDatasets.map(function (ds) { return ds.dataSet; }),
                            }];
                }
            });
        }); }
        : null;
    return sdk_ui_1.useCancelablePromise({ promise: promise, onCancel: onCancel, onError: onError, onLoading: onLoading, onPending: onPending, onSuccess: onSuccess }, [
        effectiveBackend,
        effectiveWorkspace,
        brokenAlertFilters,
    ]);
}
exports.useBrokenAlertFiltersMeta = useBrokenAlertFiltersMeta;
//# sourceMappingURL=useBrokenAlertFiltersMeta.js.map